import React from 'react';
import { IconUserCircle } from '@tabler/icons-react';
import { getDisplayName } from '../../../utils/userDisplay.js';

const UserAvatarInfo = ({ userData, className = '' }) => {
  // Enhanced avatar resolution
  const avatar = userData?.photoURL || userData?.userPhotoURL;
  const hasValidAvatar = avatar && avatar !== 'null' && avatar !== 'undefined' && avatar.trim() !== '';
  
  return (
    <div className={`user-avatar-info ${className}`.trim()}>
      {hasValidAvatar ? (
        <img
          src={avatar}
          alt={getDisplayName({ profile: userData || null, candidates: [userData?.username, userData?.displayName, userData?.name] })}
          className="postbox__avatar-img"
        />
      ) : (
        <IconUserCircle className="postbox__avatar" />
      )}
    </div>
  );
};

export default UserAvatarInfo;